import { Component, OnInit } from '@angular/core';
import { LeaderboardService } from '../../services/leaderboard.service';
import { DashboardService } from 'src/app/shared/services/dashboard.service';
import { Router } from '@angular/router';
import { Store } from 'src/app/core/store/store';
import { takeUntil } from 'rxjs/operators';
import { HandleSubscription } from 'src/app/shared/utils/handle-subscription';
import { EventsService } from 'src/app/shared/services/events.service';

@Component({
  selector: 'app-leaderboard',
  templateUrl: './leaderboard.component.html',
  styleUrls: ['./leaderboard.component.scss'],
})
export class LeaderboardComponent extends HandleSubscription implements OnInit {

  data:any;
  userList = [];
  userData = [];
  isLoader;
  programactivationId:any;
  programId:any;
  userId:any;
  scrollCount:number;
  showLoaderDashboard = false;
  loadingImg:boolean = false;
  onScrollDataLoad:boolean = true;
  user:any;
  showDescriptionModal = false;

  constructor(
    private leaderBoardService: LeaderboardService,
    private dashboardService: DashboardService,
    private router: Router,
    private store: Store,
    private eventsService: EventsService
  ) {
    super()
  }


  ordinalNumber(value){
    if (isNaN(value) || value < 1) {
      return '';
    }

    const suffixes = ['th', 'st', 'nd', 'rd'];
    const remainder = value % 100;
    const suffix = suffixes[(remainder - 20) % 10] || suffixes[remainder] || suffixes[0];

    return value + suffix;
  }

  ngOnInit(): void {
    this.scrollCount = 0;
    this.store.select('user').pipe(takeUntil(this.unsubscribe$)).subscribe((user: any) => {
      this.user = user;
    });
    this.store.select('programData').pipe().subscribe((activation: any) => {
      if(activation) {
        this.showLoaderDashboard = false;
        // this.programData = activation
        this.captureViewLeaderboard(activation)
      }
    });
    this.store.select('activationInfo').pipe().subscribe((activation: any) => {
      if(activation) {
        // this.activationInfo = activation
        this.programactivationId = activation.programActivationId
        this.programId = activation.programId

    this.getProgramActivation();
      }
    });
  }

  getProgramActivation() {
    this.showLoaderDashboard = true;
    this.data  = {
      "programActivationId": this.programactivationId,
      "page": this.scrollCount,
      "limit": 15
    };
    this.getUserRankdata(this.data);
  }

  getUserRankdata (data) {
    this.leaderBoardService.getNotesData(data).subscribe(res => {
      if(res.currentUser.length == undefined){
        this.userData = [];
        this.userData.push(res.currentUser);
      }
      if(!res.userList.length){
        this.onScrollDataLoad =  false;
      }
      this.userList = this.userList.concat(res.userList);
      this.loadingImg = false;
      this.showLoaderDashboard = false;
    });
  }

  checkthis(e){
    if(e.target.scrollHeight == e.target.scrollTop+e.target.offsetHeight && this.onScrollDataLoad) {
      if(this.userList.length){
        this.loadingImg = true;
      }
      this.scrollCount++;
      this.data.page = this.scrollCount;
      this.getUserRankdata(this.data);
    }
  }

  redirectMethod(){
    this.router.navigate(['/dashboard']);
  }

  captureViewLeaderboard(data){
    try {
      if(this.user && data) {
        let eventData = { user: this.user, activationData: data };
        this.eventsService.viewLeaderboardEvent(eventData);
      }
    } catch (err) {
      console.log(err);
    }
  }

  openDescriptionModal(){
    this.showDescriptionModal= true;
  }

  closeDescriptionModel(value){
    this.showDescriptionModal= false;
  }
}
